import { render, staticRenderFns } from "./MyKennels.vue?vue&type=template&id=55b7a2d6"
import script from "./MyKennels.vue?vue&type=script&lang=ts"
export * from "./MyKennels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports